import { render, staticRenderFns } from "./blackmailPersonnel.vue?vue&type=template&id=20d165f8&"
import script from "./blackmailPersonnel.vue?vue&type=script&lang=js&"
export * from "./blackmailPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports